export default __webpack_public_path__ + "static/media/805.df12ca1a.png";